import { getOtherSetting, login, logout, getInfo, getUserAvatar, updateUserAvatar, updateUserName, refreshToken, thirdPartyLogin, loginProvider } from '@/api/login'
import { getToken, setToken, removeToken, getImprove, setImprove, setPWD, getPWD } from '@/utils/auth'
import { blobToBase64 } from '@/utils'
import zango from 'zangodb'

const user = {
  state: {
    token: getToken(),
    name: '',
    currentName: '',
    userId: 0,
    avatar: '',
    roles: [],
    solutionId: '',
    ak: '', // 百度地图密钥
    improve: eval(getImprove()) || false, // 密码策略
    improvePwd: getPWD(),
    permission: []
  },
  mutations: {
    SET_PERMISSION: (state, permission) => {
      state.permission = permission
    },
    SET_IMPROVEPWD: (state, improvePwd) => {
      state.improvePwd = improvePwd
    },
    SET_IMPROVE: (state, improve) => {
      state.improve = improve
    },
    SET_AK: (state, ak) => {
      state.ak = ak
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_SOLUTIONID: (state, solutionId) => {
      state.solutionId = solutionId
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_CURRENTNAME: (state, currentName) => {
      state.currentName = currentName
    }
  },

  actions: {
    setPermission({ commit }, permission) {
      commit('SET_PERMISSION', permission)
    },
    setImprovePwd({ commit }, improvePwd) {
      commit('SET_IMPROVEPWD', improvePwd)
      setPWD(improvePwd)
    },
    setImprove({ commit }, improve) {
      commit('SET_IMPROVE', improve)
      setImprove(improve)
    },
    setAK({ commit }) {
      const params = { id: 'map' }
      getOtherSetting(params).then(response => {
        commit('SET_AK', response.data)
      })
    },
    // 刷新token
    refreshToken({ commit, state }, param) {
      return new Promise((resolve, reject) => {
        refreshToken(param.sid, param.refresh).then(response => {
          if (response.data.retcode === 0) {
            var data = response.data.data
            const token = `${data.token_type} ${data.access_token}`
            const nowDate = Date.now()
            const expires = nowDate + +(parseInt(data.expires_in) - 300 + '000')
            commit('SET_TOKEN', token)
            setToken(token, data.refresh_token, expires)
            var dbTable = {
              template: ['id', 'stamp', 'hash', 'file', 'sid'],
              log: ['uid', 'stamp', 'url', 'stateCode'],
              temporary: ['userId', 'templateId', 'sid', 'guid', 'remark', 'date', 'data'],
              tokenLog: ['sendTime', 'oldToken', 'newToken']
            }
            var db = new zango.Db('client', 3, dbTable)
            const tokenLog = db.collection('tokenLog')
            tokenLog.insert({
              time: new Date().getTime(),
              oldToken: state.token,
              newToken: data.access_token
            }).then(() => {
              tokenLog.remove({
                time: { $lt: (new Date().getTime()) - 86400000 }
              }).then(() => {
                resolve()
              })
            })
          }
        })
      })
    },
    // 登录方法
    LoginFn({ commit }, response) {
      return new Promise((resolve, reject) => {
        if (response.data.retcode === 0) {
          var data = response.data.data
          const token = `${data.token_type} ${data.access_token}`
          const nowDate = Date.now()
          const expires = nowDate + +(parseInt(data.expires_in) - 300 + '000')
          commit('SET_TOKEN', token)
          commit('SET_IMPROVE', data.improve_pwd)
          setImprove(data.improve_pwd)
          setToken(token, data.refresh_token, expires)
          resolve(data)
        } else {
          reject(response.data)
        }
      })
    },
    // 登录
    Login({ commit }, userInfo) {
      userInfo.username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          console.log(response.data.data)
          if (response.data.retcode === 0) {
            var data = response.data.data
            const token = `${data.token_type} ${data.access_token}`
            const nowDate = Date.now()
            const expires = nowDate + +(parseInt(data.expires_in) - 300 + '000')
            commit('SET_TOKEN', token)
            commit('SET_IMPROVE', data.improve_pwd)
            setImprove(data.improve_pwd, userInfo.solution)
            setToken(token, data.refresh_token, expires, userInfo.solution)
            resolve(data)
          } else {
            reject(response.data)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 单点登录
    loginProvider({ commit }, params) {
      return new Promise((resolve, reject) => {
        loginProvider(params).then(response => {
          if (response.data.retcode === 0) {
            var data = response.data.data
            const token = `${data.token_type} ${data.access_token}`
            const nowDate = Date.now()
            const expires = nowDate + +(parseInt(data.expires_in) - 300 + '000')
            commit('SET_TOKEN', token)
            setToken(token, data.refresh_token, expires)
            resolve()
          } else {
            reject(response.data.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 第三方登录
    thirdPartyLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        thirdPartyLogin(userInfo).then(response => {
          if (response.data.retcode === 0) {
            var data = response.data.data
            const token = `${data.token_type} ${data.access_token}`
            const nowDate = Date.now()
            const expires = nowDate + +(parseInt(data.expires_in) - 300 + '000')
            commit('SET_TOKEN', token)
            setToken(token, data.refresh_token, expires)
            resolve()
          } else {
            reject(response.data.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 设置token
    setAnonymousToken({ commit }, tokenInfo) {
      return new Promise((resolve, reject) => {
        const token = `${tokenInfo.token_type} ${tokenInfo.access_token}`
        const nowDate = Date.now()
        const expires = nowDate + +(parseInt(tokenInfo.expires_in) - 300 + '000')
        commit('SET_TOKEN', token)
        setToken(token, tokenInfo.refresh_token, expires)
        resolve()
      })
    },
    // 修改当前用户昵称
    UpdateUserName({ commit, state }, name) {
      return new Promise((resolve, reject) => {
        updateUserName(state.userId, name).then(() => {
          commit('SET_CURRENTNAME', name)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改当前用户头像
    UpdateCurrentUserAvatar({ commit }, avatarData) {
      return new Promise((resolve, reject) => {
        updateUserAvatar(avatarData.id, avatarData.data).then(() => {
          getUserAvatar(avatarData.id).then(response => {
            blobToBase64(response.data).then(url => {
              commit('SET_AVATAR', url)
              resolve()
            })
          })
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(0).then(response => {
          const data = response.data
          commit('SET_NAME', data.loginName)
          commit('SET_USERID', data.id)
          commit('SET_CURRENTNAME', data.name)
          commit('SET_PERMISSION', data.permissions)
          if (data.avatar === '1' && state.avatar === '') {
            getUserAvatar(data.id).then(response => {
              blobToBase64(response.data).then(url => {
                commit('SET_AVATAR', url)
              })
            })
          }

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },
    setSolutionId({ commit }, solutionId) {
      commit('SET_SOLUTIONID', solutionId)
    }
  }
}

export default user
